/**
 * Utility functions for question-related operations
 */

/**
 * Converts a comma-separated string of question IDs to an array
 * @param questionIdsString - Comma-separated string of question IDs
 * @returns Array of trimmed question IDs, or undefined if input is empty
 */
export const parseQuestionIds = (questionIdsString?: string): string[] | undefined => {
  if (!questionIdsString || questionIdsString.trim() === '') {
    return undefined;
  }

  return questionIdsString
    .split(',')
    .map((id) => id.trim())
    .filter((id) => id.length > 0);
};

/**
 * Converts an array of question IDs to a comma-separated string
 * @param questionIds - Array of question IDs
 * @returns Comma-separated string, or empty string if array is empty/undefined
 */
export const formatQuestionIds = (questionIds?: string[]): string => {
  if (!questionIds || questionIds.length === 0) {
    return '';
  }

  return questionIds.join(', ');
};
